import React from 'react'
import { Container, Text } from './CoreInfoUpdated.css'

interface CoreInfoConfig {
  message?: string;
}
interface CoreInfoUpdatedProps {
  config?: CoreInfoConfig;
  forSku?: boolean;
  forPlp?: boolean;
  forCart?: boolean;
  forCheckout?: boolean;
  forAccount?: boolean;
  hasStrikePrice?: boolean;
}

export default function CoreInfoUpdated(props: CoreInfoUpdatedProps) {
  const { config, forSku, forPlp, forCart, forCheckout, forAccount, hasStrikePrice } = props
  const { message = '' } = config || {}

  return (
    <Container
      id="coreInfo"
      forCart={forCart}
      forCheckout={forCheckout}
      forSku={forSku}
      forPlp={forPlp}
      forAccount={forAccount}
      hasStrikePrice={hasStrikePrice}
    >
      <Text>
        {message}
      </Text>
    </Container>
  )
}

CoreInfoUpdated.defaultProps = {
  config: {},
  forSku: false,
  forCart: false,
  forCheckout: false,
  forPlp: false,
  forAccount: false,
  hasStrikePrice: true,
}
